import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";
import { Box, Typography } from "@mui/material";

const data = [
  { name: "Dark Knight", views: 500 },
  { name: "Mission Impossible", views: 1000 },
  { name: "Iron Man", views: 800 },
  { name: "Minority Report", views: 300 },
];

const ContentViewBarGraph = () => {
  return (
    <Box
      sx={{
        border: "1px solid lightgrey",
        padding: "20px",
        borderRadius: "15px",
      }}
      textAlign="center"
    >
      <Typography variant="p" gutterBottom>
        Content Views per Movie
      </Typography>

      <BarChart
        width={500}
        height={300}
        data={data}
        layout="vertical"
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" />
        <YAxis type="category" dataKey="name" style={{ fontSize: "12px" }} />
        <Tooltip />
        <Legend />
        <Bar dataKey="views" fill="#8884d8" barSize={20} />
      </BarChart>
    </Box>
  );
};

export default ContentViewBarGraph;
